"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _videoChannel = require("@/api/videoChannel");
var _validate = require("@/utils/validate");
var _vuex = require("vuex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var defaultObj = {
  image: '',
  sliderImages: [],
  videoLink: '',
  sliderImage: '',
  storeName: '',
  storeInfo: '',
  keyword: '',
  cateIds: [],
  // 商品分类id
  couponList: [],
  cateId: null,
  // 商品分类id传值
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  isSub: false,
  content: '',
  specType: false,
  id: undefined,
  couponIds: [],
  coupons: [],
  postage: '1',
  categoryId: '',
  guaranteeIds: '',
  guaranteeIdsList: [],
  brandId: ''
};
var objTitle = {
  price: {
    title: '售价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '划线价'
  },
  stock: {
    title: '库存'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
var _default2 = exports.default = {
  name: 'ProductProductAdd',
  props: {
    isAtud: {
      type: Boolean,
      default: false
    },
    productId: {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      rules: {
        platformEditStatus: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        platformStatusReason: [{
          required: true,
          message: '请填写拒绝原因',
          trigger: 'blur'
        }]
      },
      isAppend: true,
      proId: 0,
      ruleForm: {
        platformStatusReason: '',
        platformEditStatus: 4,
        draftProductId: ''
      },
      direction: 'rtl',
      dialogVisible: false,
      isDisabled: true,
      props2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      props1: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      checkboxGroup: [],
      recommend: [{
        name: '可能喜欢',
        value: 'isGood',
        type: '5'
      }, {
        name: '热卖商品',
        value: 'isHot',
        type: '2'
      }, {
        name: '主打商品',
        value: 'isBest',
        type: '1'
      }],
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 多规格
      ruleList: [],
      merCateList: [],
      // 商户分类筛选
      shippingList: [],
      // 运费模板
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      tempData: {
        page: 1,
        limit: 9999
      },
      manyTabTit: {},
      manyTabDate: {},
      grid2: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: 0,
      isChoice: '',
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      attrInfo: {},
      tableFrom: {
        page: 1,
        limit: 9999,
        keywords: ''
      },
      tempRoute: {},
      keyNum: 0,
      isAttr: false,
      showAll: false,
      videoLink: '',
      search: {
        limit: 10,
        page: 1,
        cid: '',
        brandName: ''
      },
      totalPage: 0,
      total: 0,
      loading: false,
      loadingBtn: false,
      propsCatId: {
        emitPath: true
      },
      productQualificationType: 0,
      //商品资质类型，0不需要，1必填，2选填
      productQualification: '' // 资质说明
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['merPlatProductClassify', 'productBrand'])), {}, {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    },
    oneFormBatch: function oneFormBatch() {
      var obj = [Object.assign({}, defaultObj.attrValue[0])];
      return obj;
    }
  }),
  watch: {
    'formValidate.attr': {
      handler: function handler(val) {
        if (this.formValidate.specType && this.isAttr) this.watCh(val); //重要！！！
      },
      immediate: false,
      deep: true
    }
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    if (this.$route.params.id && this.formValidate.specType) {
      this.$watch('formValidate.attr', this.watCh);
    }
    if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
  },
  mounted: function mounted() {
    if (this.dialogVisible) {
      this.setTagsViewTitle();
      this.ruleForm.platformStatusReason = '';
      this.ruleForm.platformEditStatus = 4;
    }
  },
  methods: {
    close: function close() {
      this.dialogVisible = false;
      this.ruleForm.platformStatusReason = '';
      this.ruleForm.platformEditStatus = 4;
    },
    onSubmit: function onSubmit(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.loadingBtn = true;
          _this.ruleForm.draftProductId = _this.productId;
          (0, _videoChannel.draftProductReviewApi)(_this.ruleForm).then(function (res) {
            _this.$message.success('操作成功');
            _this.dialogVisible = false;
            _this.currentTab = '0';
            _this.ruleForm.platformStatusReason = '';
            _this.ruleForm.platformEditStatus = 4;
            _this.$emit('subSuccess');
            _this.loadingBtn = false;
          }).catch(function (res) {
            _this.loadingBtn = false;
          });
        } else {
          return false;
        }
      });
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.isDisabled ? '商品详情' : '编辑商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    watCh: function watCh(val) {
      var _this2 = this;
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        // tmp['value' + i] = { title: o.attrName }
        // tmpTab['value' + i] = ''
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.ManyAttrValue = this.attrFormat(val);
      this.ManyAttrValue.forEach(function (val, index) {
        var key = Object.values(val.attrValue).sort().join('/');
        if (_this2.attrInfo[key]) _this2.ManyAttrValue[index] = _this2.attrInfo[key];
      });
      this.attrInfo = [];
      this.ManyAttrValue.forEach(function (val) {
        _this2.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);
      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            if (!data) return;
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);
                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    cost: 0,
                    otPrice: 0,
                    stock: 0,
                    weight: 0,
                    volume: 0
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });
                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }
                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                cost: 0,
                otPrice: 0,
                stock: 0,
                weight: 0,
                volume: 0,
                attrValue: _defineProperty({}, v['attrName'], vv)
              };
              // Object.values(res[kk].attrValue).forEach((v, i) => {
              //   res[kk]['value' + i] = v
              // })
              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }
        return res;
      }
    },
    // 详情
    getInfo: function getInfo(id) {
      var _this3 = this;
      this.loading = true;
      (0, _videoChannel.draftInfoApi)(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var info;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                // this.isAttr = true;
                info = res;
                _this3.formValidate = {
                  images: JSON.parse(info.headImg),
                  title: info.title,
                  unitName: info.unitName,
                  tempId: info.tempId,
                  attr: JSON.parse(info.attr),
                  descInfo: info.descInfo,
                  specType: info.specType,
                  primaryProductId: info.primaryProductId,
                  giveIntegral: info.giveIntegral,
                  ficti: info.ficti,
                  thirdCatIdList: [info.catInfo.firstCatName, info.catInfo.secondCatName, info.catInfo.thirdCatName],
                  thirdCatId: info.thirdCatId,
                  brandId: info.brandId,
                  qualificationPicsList: JSON.parse(info.qualificationPics) || [],
                  id: info.id
                };
                _this3.ManyAttrValue = JSON.parse(info.attrValue);
                _this3.$nextTick(function () {
                  _this3.ManyAttrValue.forEach(function (item, index) {
                    item.attrValue = JSON.parse(item.attrValue);
                    for (var attrValueKey in item.attrValue) {
                      item[attrValueKey] = item.attrValue[attrValueKey];
                    }
                    if (item.id) {
                      _this3.$set(item, 'price', item.price);
                      _this3.$set(item, 'quota', item.quota);
                    }
                  });
                });
                _this3.loading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this3.loading = false;
      });
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    }
  }
};